import axios from 'axios'

export class Sammelpunkte{
    static async get(konvKey){
        try {
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/sammelpunkte',
                { params: { konvKey: konvKey } }
            );

            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async add(x, y, beschreibung, feuerwehrID){
        const sammelpunktData= {
            position: {x: x, y: y},
            beschreibung: beschreibung,
            feuerwehrID: feuerwehrID
        };

        try {
            const response = await axios.post(
                'https://feuerwehr-server.org:5000/addSammelpunkt',
                sammelpunktData
            );
            console.log(response.data)
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async delete(id, feuerwehrID){
        try {
            const response = await axios.delete(
                'https://feuerwehr-server.org:5000/deleteSammelpunkt',
                { params: { id: id, feuerwehrID: feuerwehrID } }
            );
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async update(id, x, y, beschreibung, feuerwehrID){
        const sammelpunktData = {
            id: id,
            beschreibung: beschreibung,
            feuerwehrID: feuerwehrID,
        };

        console.log(sammelpunktData);
        try {
            const response = await axios.put(
                'https://feuerwehr-server.org:5000/updateSammelpunkt',
                sammelpunktData
            );
            console.log(response);
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
}
